import type { Document } from "@repo/types";
import React, { createContext, useContext } from "react";

export const DocumentDefaultsContext = createContext<Partial<Document> | null>(
  null
);

export const DocumentDefaults = ({
  defaults,
  children,
}: {
  defaults: Partial<Document>;
  children?: React.ReactNode;
}) => {
  const prevDefaults = useContext(DocumentDefaultsContext);
  const nextDefaults = { ...prevDefaults, ...defaults };

  return (
    <DocumentDefaultsContext.Provider value={nextDefaults}>
      {children}
    </DocumentDefaultsContext.Provider>
  );
};
